<template>
    <VideoUploadModal :upload-route="frenchUploadRoute"
                      :delete-route="frenchDeleteRoute"
                      :custom-title="frenchTitle"
                      :attribute-name="frenchAttribute"
                      :max-file-size="maxFileSize"
                      :accepted-file-types="acceptedFileTypes"
                      :video="frenchVideo" />
    <VideoUploadModal :upload-route="englishUploadRoute"
                      :delete-route="englishDeleteRoute"
                      :custom-title="englishTitle"
                      :attribute-name="englishAttribute"
                      :max-file-size="maxFileSize"
                      :accepted-file-types="acceptedFileTypes"
                      :video="englishVideo" />
</template>

<script>
import VideoUploadModal from '@components/VideoUploadModal.vue'
export default {
    name: 'AdviserProfileEditPage',
    components: {
        VideoUploadModal
    },
    props: {
        frenchUploadRoute: {
            type: String,
            required: true
        },
        englishUploadRoute: {
            type: String,
            required: true
        },
        frenchDeleteRoute: {
            type: String,
            required: true
        },
        englishDeleteRoute: {
            type: String,
            required: true
        },
        frenchVideo: {
            type: String,
            default: ''
        },
        englishVideo: {
            type: String,
            default: ''
        },
        frenchTitle: {
            type: String,
            default: 'French Video'
        },
        englishTitle: {
            type: String,
            default: 'English Video'
        },
        frenchAttribute: {
            type: String,
            default: ''
        },
        englishAttribute: {
            type: String,
            default: ''
        },
        acceptedFileTypes: {
            type: String,
            default: ''
        },
        maxFileSize: {
            type: String,
            default: '8 MB'
        },
    }
}
</script>
